import { LanguageConfig, STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY, STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY, STAMP_CAMPAIGN_RULE_PAGE_ANCHOR_KEY } from "config/CustomEnums";
import { validateContentPage } from "../campaignStreamline/CreateCampaignValidate";
import { StampCampaignErrorHandleField } from "components/stampCampaign/stampCampaignCreation/CreateStampCampaignHandleError";
import { validateEarningPage } from "../earningRule/CreateEarningRuleValidate";
import { EarningRuleErrorHandleField } from "components/earning/EarningRuleHandleError";
import { validateStampRewards } from "../campaign/CreateCampaignValidate";


const validateStampCampaignContentPage = ({
  getValues,
  languages,
}) => {
  const errorList = [
    ...validateContentPage({
    getValues,
    languages,
    hideInFrontend: false,
  })];
  const [
    useUploadStampIcons,
    emptyStampSlot,
    collectedStamp,
    emptyGiftStampSlot,
    collectedGift,
  ] = getValues([
    'useUploadStampIcons',
    'stampCampaignTypeEmptySlotStampImage',
    'stampCampaignTypeAcquiredStampImage',
    'stampCampaignTypeEmptyGiftSlotImage',
    'stampCampaignTypeCollectedGiftImage',
  ]);

  if (useUploadStampIcons) {
    if (!emptyStampSlot) {
      errorList.push({
        sectionKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual.sectionKey,
        name: 'stampCampaignTypeEmptySlotStampImage',
        message: StampCampaignErrorHandleField.fileRequired.message,
      });
    }
    if (!collectedStamp) {
      errorList.push({
        sectionKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual.sectionKey,
        name: 'stampCampaignTypeAcquiredStampImage',
        message: StampCampaignErrorHandleField.fileRequired.message,
      });
    }
    if (!emptyGiftStampSlot) {
      errorList.push({
        sectionKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual.sectionKey,
        name: 'stampCampaignTypeEmptyGiftSlotImage',
        message: StampCampaignErrorHandleField.fileRequired.message,
      });
    }
    if (!collectedGift) {
      errorList.push({
        sectionKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual.sectionKey,
        name: 'stampCampaignTypeCollectedGiftImage',
        message: StampCampaignErrorHandleField.fileRequired.message,
      });
    }
  }

  return errorList;
}

// validate stamp tasks
const validatePropertiesPage = ({
  getValues,
  languages,
}) => {
  let errorList  =[];
  const [
    stampTasks,
  ] = getValues([
    'stampTasks',
  ]);
  if (!stampTasks || !stampTasks?.length > 0) {
    errorList.push({
      sectionKey: STAMP_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.tasks.sectionKey,
      name: StampCampaignErrorHandleField.stampTasks.name,
      message: StampCampaignErrorHandleField.stampTasks.message,
    });
  } else {
    stampTasks.forEach((stampTask, index)=>{
      if (!stampTask?.type) {
        errorList.push({
          sectionKey: STAMP_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.tasks.sectionKey,
          name: `stampTasks.${index}.type`,
          message: "Please select a type.",
        }); 
      }
      if (!stampTask?.translations?.[LanguageConfig.english]?.generalName && !stampTask?.name) {
        errorList.push({
          sectionKey: STAMP_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.tasks.sectionKey,
          name: `stampTasks.${index}.generalName`,
          message: EarningRuleErrorHandleField.generalName.message,
        });
      }
      const earningPageError = validateEarningPage({ getValues, prefix: `stampTasks.${index}.`, isCampaignStreamLine: true });
      errorList = [
        ...errorList,
        ...earningPageError?.map(err => ({ ...err, sectionKey: STAMP_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.tasks.sectionKey, })),
      ];
    })
  }
  return errorList;
 }

const validateRewardsPage = ({
  getValues,
  languages,
}) => {
  let errorList = validateStampRewards({ getValues })
  const [
    executionPriority,
  ] = getValues([
    'executionPriority',
  ])
  if (!executionPriority || executionPriority < 1) {
      errorList.push({
        sectionKey: STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY.executionPriority.sectionKey,
        name: 'executionPriority',
        message: "Please provide a valid execution priority",
    });
  }
  return errorList;
 }


const validatePreviewPage = ({
  getValues,
  languages,
}) => {
  let errorList = []
  return errorList;
 }

export function validate({
  dispatch,
  getValues,
  setError,
  clearErrors,
  checkCheckList = false,
  languages = [LanguageConfig.english],
}) {
  clearErrors();

  let errorList = [];
  const errorSectionList = [];

  const contentPageError = validateStampCampaignContentPage({ getValues, languages });
  const propertiesPageError = validatePropertiesPage({ getValues });
  const rewardsPageError = validateRewardsPage({ getValues });
  const previewPageError = validatePreviewPage({ getValues, checkCheckList });
  errorList = [
    ...contentPageError,
    ...propertiesPageError,
    ...rewardsPageError,
    ...previewPageError,
  ];

  errorList.forEach(item => {
    if (item.sectionKey) {
      errorSectionList.push(item.sectionKey);
    }
  })

  errorList.forEach((error) => {
    setError(error.name, {
      type: 'manual',
      message: error.message,
    });
  });

  dispatch({
    type: 'createCampaign/updateState',
    payload: {
      errorFields: errorList.map(item => item.name),
      errorSectionList,
    }
  })

  return !errorList.length;

}